import { Alert } from '@mui/material'
import React from 'react'

import Icon from 'components/Icon'

export const PendingNamespaceAccessRequestAlert: React.FC<{
  title: string
}> = ({ title }) => {
  return (
    <Alert
      data-testid="alert-pending-namespace-access-request"
      icon={<Icon icon="solidCirclesOverlap" />}
      severity="info"
      sx={{ width: 'fit-content' }}
    >
      {title}
    </Alert>
  )
}
